module.exports = __webpack_public_path__ + "static/nxrt-esports4-f871dd50b3f033cf712bca510b9e9131.jpg";